import React, { useState } from 'react';
import TodoItem from './ToDoItem';
import TodoForm from './ToDoForm';

const TodoList = ({ tasks, setTasks, token }) => {
    const [filter, setFilter] = useState('all');

    const filteredTasks = tasks.filter(task => {
        if (filter === 'active') return !task.completed;
        if (filter === 'completed') return task.completed;
        return true;
    });

    return (
        <div className="space-y-8">
            <TodoForm setTasks={setTasks} token={token} />
            <div className="flex justify-center space-x-2">
                {['all', 'active', 'completed'].map((f) => (
                    <button
                        key={f}
                        onClick={() => setFilter(f)}
                        className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 ${filter === f
                                ? 'bg-blue-600 text-white shadow-md transform scale-105'
                                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                            }`}
                    >
                        {f.charAt(0).toUpperCase() + f.slice(1)}
                    </button>
                ))}
            </div>
            <div className="space-y-3">
                {filteredTasks.map(task => (
                    <TodoItem key={task._id} task={task} setTasks={setTasks} token={token} />
                ))}
            </div>
            {filteredTasks.length === 0 && (
                <div className="text-center py-8">
                    <svg className="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                    <p className="text-gray-500 text-lg">No tasks to display</p>
                </div>
            )}
        </div>
    );
};

export default TodoList;
